import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {Operator, Order, Sort, UrlParameter} from '../../../../../../shared/utils/url.builder';
import {SelectSearchDataComponent} from '../../../../../../components/common/select-search-data/select-search-data.component';
import {NewItemModalOptions} from '../../../../../core/component/select/abstract-select.component';
import {PartnerModel} from '../../model/partner.model';
import {PartnerControl} from '../../control/partner.control';
import {PartnerSearchService} from '../../service/partnerSearch.service';
import {
    PartnerSaveDialogComponent,
    PartnerSaveDialogInput,
    PartnerSaveDialogOutput
} from '../partner-save-dialog/partner-save-dialog.component';
import {PartnerSummaryModel} from '../../model/partnerSummary.model';

@Component({
  selector: 'app-partner-search',
  templateUrl: './partner-search.component.html',
  providers: [PartnerSearchService],
})
export class PartnerSearchComponent {

    @ViewChild('selectSearch') selectSearchComponent: SelectSearchDataComponent<PartnerModel>;

  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;
  @Input() placeHolder = 'Chercher';
  @Input() noEntryPlaceHolder = 'Aucun partenaire trouvé';
  @Input() typeValue: string;
  @Input() value: PartnerSummaryModel;
  @Input() parameterSearch = 'name';
  @Input() searchTerm: string;
  @Input() automaticSelectIfOneResult = false;

  @Input() newItemModalOptions:
      NewItemModalOptions<PartnerSaveDialogOutput, PartnerSaveDialogInput, PartnerSaveDialogComponent>;
  @Output() changeEvent = new EventEmitter<PartnerSummaryModel>();

    sort = new Sort('name', Order.ASCENDING);


  constructor(public partnerSearchService: PartnerSearchService,
              public partnerControl: PartnerControl) {
  }


  get additionalUrlParameters(): UrlParameter[] {
    return this.typeValue ? [new UrlParameter('type.value', this.typeValue, Operator.EQUALS)] : [];
  }

  getLabel(partner: PartnerModel) {
      return this.partnerControl.toString(partner, !this.typeValue, true);
  }

    getSelectedElement(): PartnerSummaryModel {
        return this.selectSearchComponent?.getSelectedElement();
    }

    change(partner: PartnerSummaryModel) {
      // console.log(['partner changed', partner, this.changeEvent]);
      if (this.changeEvent) {
          this.changeEvent.emit(partner);
      }
    }

    setValue(value: string, emitEvent = true): Promise<PartnerModel> {
        return new Promise<PartnerModel>((resolve, reject) => {
            this.selectSearchComponent?.setValueById(value, emitEvent)
                .then(value1 => resolve(value1))
                .catch(reason => reject(reason));
        });
    }

    entityLoaded(entity: PartnerModel, emitEvent = true) {
        this.selectSearchComponent.entityLoaded(entity, emitEvent);
    }

}
